import { useFeatures } from 'components/use_organization'

export const useOnetrust = () => {
  const { data } = useFeatures()
  if (!data) return null
  return data.onetrust
}
